import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import createInfo from "./CourierCharges.module.css";
import { AxiosInstance } from "../../../../axios";
import toast from "react-hot-toast";
import Loader from "../../Loader";
import ConfirmationPopup from "../TestAdminWorkflow/Gallery/ConfirmationPopup/ConfirmationPopup";

export default function EditCourierCharges() {
  const { id } = useParams();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  }

  const navigate = useNavigate();
  const [initialfields, setInitialfields] = useState({
    amount: "",
    start_gram_range: "",
    end_gram_range: "",
    isActive: 1,
  });
  const [oldData, setOldData] = useState({});
  const [tempData, setTempData] = useState({});
  const [isPurchase, setIsPurchase] = useState(0); // new state
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const amount = useRef(null);

  const validateFields = (data) => {
    const errors = {};
    const amountStr = data.amount ? data.amount.toString() : "";
    const amount = parseInt(data.amount, 10);

    if (!data.amount || isNaN(amount)) {
      errors.amount = "Enter the amount";
    } else if (amount <= 0) {
      errors.amount = "Amount must be greater than 0";
    } else if (!/^\d+$/.test(data.amount)) {
      errors.amount = "Amount must be a whole number (no decimals allowed)";
    } else if (amountStr.length > 5) {
      errors.amount = "Amount cannot be more than 5 digits";
    }

    setError(errors);
    validateFocusCommentSection(data);
    return errors;
  };

  const validateFocusCommentSection = (data) => {
    if (!data.amount) {
      amount.current.focus();
    }
  };

  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/book/courier/view", { id: parseInt(id) })
      .then((res) => {
        if (res.data.status === true && res.data.data?.length > 0) {
          const courseData = res.data.data[0];
          setInitialfields({
            start_gram_range: courseData.start_gram_range,
            end_gram_range: courseData.end_gram_range,
            amount: courseData.amount,
            isActive: courseData.isActive,
          });
          setOldData({
            start_gram_range: courseData.start_gram_range,
            end_gram_range: courseData.end_gram_range,
          });
          setTempData({
            start_gram_range: courseData.start_gram_range,
            end_gram_range: courseData.end_gram_range,
          });
          setIsPurchase(courseData.is_purchase || 0); // set is_purchase
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [id]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "start_gram_range" || name === "end_gram_range") {
      setTempData((prev) => ({ ...prev, [name]: value }));
      if (initialfields.isActive === 1) {
        setInitialfields((prevFields) => ({ ...prevFields, [name]: value }));
      }
    } else {
      setInitialfields((prevFields) => ({ ...prevFields, [name]: value }));
    }

    setError((prev) => ({ ...prev, [name]: "" }));
  };

  const handleStatusChange = (value) => {
    setInitialfields((prev) => {
      let updated = { ...prev, isActive: value };

      if (value === 0) {
        updated.start_gram_range = oldData.start_gram_range;
        updated.end_gram_range = oldData.end_gram_range;
      } else {
        updated.start_gram_range = tempData.start_gram_range;
        updated.end_gram_range = tempData.end_gram_range;
      }

      return updated;
    });
  };

  const handleSubmit = () => {
    const errors = validateFields(initialfields);
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    try {
      const courierData = {
        id: id,
        start_gram_range: initialfields.start_gram_range,
        end_gram_range: initialfields.end_gram_range,
        amount: initialfields.amount,
        is_active: initialfields.isActive,
        updated_by: userid,
      };

      AxiosInstance.post(`/api/book/courier/edit`, courierData)
        .then((res) => {
          const { status, message, amtErr, editErr, mapErr } = res.data;

          if (mapErr === true) {
            setShowModal(true);
          } else if (status === true) {
            toast.success(message);
            handleClose();
            navigate(`/CourierCharges`);
          } else {
            let newErrors = {};
            if (editErr === false) {
              newErrors.start_range = message;
              newErrors.end_range = message;
              handleClose();
            }

            if (amtErr === false) {
              newErrors.amount = message;
              handleClose();
            }

            setError((prev) => ({ ...prev, ...newErrors }));
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        });
    } catch (error) {
      console.error("Unexpected Error:", error);
    }
  };

  const navigateToPreviousScreen = () => {
    navigate(-1);
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className={`${createInfo.CourseInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">Edit Courier Charge</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                onClick={navigateToPreviousScreen}
                className="secondaryButton"
              >
                Back to View Courier Charge
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={() => handleSubmit()}
                className="primaryButton text-center"
              >
                Save Courier Charge
              </Link>
            </li>
          </ul>
        </div>

        {/* Conditionally show note */}
        {isPurchase === 1 && (
          <div className="my-lg-4">
            <div className="col-lg-12">
              <span className={createInfo.alert_info}>
                <strong> Note :</strong>
                This courier charge has already been used in a purchase. Saving
                will deactivate the existing entry and a new one will be created
                and set as active.
              </span>
            </div>
          </div>
        )}

        {/* courier Details */}
        <div className="row m-0 mb-5">
          <fieldset className="mt-3">
            <legend className="w-auto">Courier Charge Details</legend>
            <form className="row g-3">
              <div className="col-md-6">
                <label className="form-label confirm_value">
                  Start Weight Range (in grams)
                </label>
                <input
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  value={initialfields.start_gram_range}
                  disabled={!initialfields.isActive}
                  name="start_gram_range"
                  onChange={handleChange}
                />
                {error.start_range && (
                  <small className={createInfo.errors}>
                    {error.start_range}
                  </small>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label confirm_value">
                  End Weight Range (in grams)
                </label>
                <input
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  value={initialfields.end_gram_range}
                  disabled={!initialfields.isActive}
                  name="end_gram_range"
                  onChange={handleChange}
                />
                {error.end_range && (
                  <small className={createInfo.errors}>{error.end_range}</small>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label confirm_value">Amount</label>
                <input
                  ref={amount}
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the amount"
                  value={initialfields.amount}
                  disabled={!initialfields.isActive}
                  name="amount"
                  onChange={handleChange}
                />
                {error.amount && (
                  <small className={createInfo.errors}>{error.amount}</small>
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label className="form-label confirm_value d-block">
                  Status
                </label>
                <div className="d-flex align-items-center">
                  <div className="form-check me-3 p-0">
                    <input
                      className={createInfo.checkbox_radio}
                      type="radio"
                      name="isActive"
                      id="activeYes"
                      value={1}
                      checked={initialfields.isActive === 1}
                      onChange={() => handleStatusChange(1)}
                    />
                    <label className="form-check-label" htmlFor="activeYes">
                      Active
                    </label>
                  </div>
                  <div className="form-check p-0">
                    <input
                      className={createInfo.checkbox_radio}
                      type="radio"
                      name="isActive"
                      id="activeNo"
                      value={0}
                      checked={initialfields.isActive === 0}
                      onChange={() => handleStatusChange(0)}
                    />
                    <label className="form-check-label" htmlFor="activeNo">
                      InActive
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </fieldset>
        </div>

        <div className="col-md-12 col-12 ListBtn mb-5">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                onClick={navigateToPreviousScreen}
                className="secondaryButton"
              >
                Back to View Courier Charge
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={() => handleSubmit()}
                className="primaryButton text-center"
              >
                Save Courier Charge
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
